angular.module("app").controller("ProvidersAddPageController", [
    '$scope',
    '$filter',
    'preloadedData',
    'pageStatuses',
    'casinoProviderService',
    'errorHandler',
    'logger',
    '$stateParams',
    '$uibModalInstance',
    'countryCodes',
    'settingsService',

    function ($scope, $filter,  preloadedData, pageStatuses, casinoProviderService, errorHandler, logger, $stateParams, $modalInstance, countryCodes, settingsService) {

        var countryNameCodeMap = {};
        $scope.countryCodes = countryCodes.data.map(function (item) {
            countryNameCodeMap[item.name] = item["alpha-2"];
            return item.name;
        });
        $scope.tooltip = {
            name: "",
            title: ""
        };


        var translator = $filter('translate'),
            settings = settingsService.getSettings();


        var tmpLanguages = [];

        angular.forEach(settings.languages, function (lang) {
            if (lang == 'en') return true;

            tmpLanguages.push({
                id: lang,
                title: lang.toUpperCase() + ' - ' + translator('top_menu.languages.' + lang),
                placeholder: 'Name'
            });
        });

        $scope.languages = tmpLanguages;


        $scope.pageStatuses = pageStatuses;

        $scope.parents = preloadedData.providers;
        
        $scope.save = function () {
            if (!$scope.add_providers_form.$valid) {
                $scope.isSavePressed = true;
                return;
            }
            var providersData = angular.copy($scope.providerData);
            providersData.blocked_countries = providersData.blocked_countries.map(function (item) {
                return countryNameCodeMap[item];
            });
            var addElementHelper = $scope.useAddElementHelper();
            providersData.translations = addElementHelper.fetchData('providerTitleTranslation');
            casinoProviderService.create({casinoProvider: providersData}).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("saved");
                        init();
                        $modalInstance.close();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.isForItem = function () {
            return !isNaN(+$stateParams.itemId)
        };

        function init() {
            $scope.providerData = {
                name: "",
                title: "",
                status: pageStatuses[0],
                blocked_countries: [],
                info: "",
            };

            $scope.add_providers_form && $scope.add_providers_form.$setPristine();
        }

        init();

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
]);
